import { Vimeo } from "../Types/vimeo";

if (!Vimeo) {
  console.error("Vimeo is not loaded");
} else {
  document.querySelectorAll("[data-vimeo-inline]").forEach(inlineVideoComponent => {
    const inlineVideo = inlineVideoComponent.querySelector("[data-vimeo-inline-video]");

    if (!inlineVideo) {
      console.error("No video element found in inline video component");
      return;
    }

    const coverImage = inlineVideoComponent.querySelector("[data-vimeo-inline-cover]");
    const playButton = inlineVideoComponent.querySelector("[data-vimeo-inline-play]");

    if (coverImage && playButton) {
      playButton.addEventListener("click", () => {
        playButton
          .querySelectorAll("[data-vimeo-play-icon], [data-vimeo-spinner]")
          .forEach(element => element.classList.toggle("scale-0"));

        const options = {
          url: inlineVideo.getAttribute("data-vimeo-inline-video"),
          dnt: true,
        };

        const videoPlayer = new Vimeo.Player(inlineVideo, options);

        videoPlayer.on("loaded", () => {
          coverImage.classList.add("opacity-0", "pointer-events-none");
          videoPlayer.play();
        });
      });
    }
  });
}
